<!-- eslint-disable vue/valid-v-model -->
<template>
  <v-card flat class="px-6">
    <v-row no-gutters>
      <v-col cols="12">
        <a type="primary" size="xsmall" @click="beforeLeave">
          <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
          {{ $t('message.actions.return') }}
        </a>
      </v-col>
    </v-row>

    <div class="grid__control">
      <div class="mb-4">
        <div class="body-bold-medium">
          {{ $t('message.pages.integrations.videoPageTitle') }}
        </div>
        <div
          class="body-regular-smaller neutral-40-light--text pt-2 pb-3 d-flex align-center"
        >
          <span>
            {{ $t('message.pages.integrations.selectEmailCrm') }}
            <a
              target="_blank"
              type="secondary"
              class="ml-1"
              :href="leadArticle"
            >
              <span>
                {{ $t('message.embedModal.knowMore') }}
              </span>
              <v-icon size="12">mdi-open-in-new</v-icon>
            </a>
          </span>
        </div>
      </div>
      <span class="body-regular-smaller textType6--text pt-5">{{
        $t('message.pages.integrations.integrationsConfig').toUpperCase()
      }}</span>
      <div
        class="body-regular-small neutral-40-light--text pt-1 pb-3 d-flex align-center"
      >
        {{ $t('message.pages.integrations.integrationsConfigDescription') }}
      </div>

      <!-- Seção de Integrações -->
      <v-card flat tile style="background: transparent" class="mb-6">
        <v-col cols="12" class="pa-0">
          <v-row
            no-gutters
            v-if="loadings.getIntegrations"
            style="width: 100%; height: 150px"
            class="align-center justify-center"
          >
            <v-progress-circular
              class="ml-2"
              width="3"
              size="20"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
          <v-row
            v-for="integration in integrations"
            v-else
            :key="integration.id"
            no-gutters
            class="justify-start align-center mb-3"
          >
            <v-col cols="5" style="display: flex; align-items: normal">
              <span
                v-if="integration.service === 'active_campaign'"
                class="mr-3"
                style="padding-top: 1px"
                ><svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="15"
                    height="15"
                    rx="1.5"
                    fill="url(#pattern0_7520_3023)"
                    stroke="#004CFF"
                  />
                  <defs>
                    <pattern
                      id="pattern0_7520_3023"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlink:href="#image0_7520_3023"
                        transform="translate(-0.141387 -0.155651) scale(0.0142901)"
                      />
                    </pattern>
                    <image
                      id="image0_7520_3023"
                      width="89"
                      height="92"
                      preserveAspectRatio="none"
                      xlink:href="data:image/png;base64,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"
                    />
                  </defs>
                </svg>
              </span>
              <span
                v-else-if="integration.service === 'mailchimp'"
                class="mr-3"
                style="padding-top: 1px"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M23.6057 15.1224C23.8394 15.0945 24.0628 15.093 24.2685 15.1224C24.3875 14.8491 24.4081 14.3788 24.3008 13.8674C24.1421 13.1062 23.9261 12.6447 23.4808 12.7167C23.0356 12.7887 23.0194 13.3398 23.1781 14.1011C23.2692 14.5287 23.4279 14.8961 23.6057 15.1224Z"
                    fill="#231F20"
                  />
                  <path
                    d="M19.785 15.7249C20.1038 15.8646 20.2993 15.9571 20.3757 15.8763C20.4257 15.8263 20.411 15.7294 20.3346 15.6059C20.1773 15.3487 19.854 15.0886 19.5116 14.9431C18.8107 14.6419 17.9745 14.7418 17.3279 15.2047C17.1148 15.3605 16.9135 15.5765 16.9414 15.7088C16.9502 15.7514 16.9826 15.7837 17.0575 15.794C17.2339 15.8146 17.8466 15.503 18.5535 15.4604C19.0531 15.4296 19.4675 15.5853 19.785 15.7249Z"
                    fill="#231F20"
                  />
                  <path
                    d="M19.1442 16.0909C18.7298 16.157 18.5006 16.2937 18.3536 16.4201C18.2287 16.5288 18.1508 16.6508 18.1508 16.736C18.1508 16.7772 18.1685 16.7992 18.1831 16.811C18.2023 16.8271 18.2243 16.8374 18.2507 16.8374C18.3448 16.8374 18.5535 16.7536 18.5535 16.7536C19.131 16.5464 19.5116 16.5729 19.8878 16.6155C20.0965 16.639 20.1949 16.6522 20.2405 16.5802C20.2537 16.5597 20.2699 16.5156 20.2287 16.448C20.1347 16.2893 19.7159 16.0233 19.1442 16.0909Z"
                    fill="#231F20"
                  />
                  <path
                    d="M22.3155 17.4326C22.5976 17.5707 22.9062 17.5164 23.0076 17.3106C23.109 17.1049 22.9621 16.8271 22.6799 16.689C22.3978 16.5508 22.0892 16.6052 21.9878 16.811C21.8878 17.0152 22.0333 17.293 22.3155 17.4326Z"
                    fill="#231F20"
                  />
                  <path
                    d="M24.1259 15.8499C23.8967 15.8455 23.7071 16.0967 23.7027 16.4112C23.6968 16.7257 23.8791 16.9829 24.1068 16.9858C24.3361 16.9902 24.5257 16.739 24.5301 16.4245C24.5359 16.1114 24.3537 15.8543 24.1259 15.8499Z"
                    fill="#231F20"
                  />
                  <path
                    d="M8.76198 21.5062C8.70467 21.4342 8.61209 21.4563 8.52097 21.4783C8.45778 21.493 8.38578 21.5092 8.30789 21.5077C8.14037 21.5048 7.99782 21.4328 7.917 21.3093C7.81266 21.1491 7.81854 20.9111 7.93316 20.6377C7.94933 20.601 7.96696 20.5598 7.98753 20.5158C8.17123 20.1043 8.47836 19.415 8.13302 18.7581C7.87291 18.2644 7.44969 17.9558 6.94123 17.8911C6.45334 17.8294 5.94929 18.0101 5.62894 18.3643C5.12342 18.9227 5.04406 19.6825 5.14105 19.9514C5.17632 20.0499 5.23363 20.0763 5.27331 20.0822C5.36001 20.094 5.48639 20.0308 5.56575 19.8162C5.57163 19.8015 5.57897 19.7766 5.58926 19.7472C5.62453 19.634 5.69066 19.4224 5.7994 19.2534C5.93019 19.0491 6.13299 18.908 6.37252 18.8581C6.61646 18.8066 6.86481 18.8522 7.07349 18.9889C7.42764 19.2211 7.56431 19.6546 7.41295 20.069C7.33506 20.2836 7.20721 20.6936 7.23513 21.0301C7.29245 21.712 7.71126 21.9853 8.08746 22.0147C8.45338 22.0279 8.70907 21.8237 8.77373 21.6723C8.81488 21.5841 8.78255 21.5298 8.76198 21.5062Z"
                    fill="#231F20"
                  />
                  <path
                    d="M12.2433 8.98687C13.438 7.60694 14.9075 6.4063 16.2257 5.73324C16.2713 5.70972 16.3197 5.75969 16.2948 5.80378C16.1904 5.99335 15.9891 6.39895 15.9244 6.70609C15.9142 6.75459 15.9671 6.78986 16.0067 6.76194C16.8267 6.2035 18.2522 5.60538 19.5013 5.5275C19.5557 5.52456 19.5806 5.59363 19.538 5.62596C19.3485 5.77145 19.1398 5.97425 18.9884 6.17852C18.962 6.21379 18.9869 6.26375 19.0296 6.26375C19.9069 6.26963 21.1457 6.57677 21.9525 7.0294C22.0068 7.06026 21.9686 7.16607 21.9069 7.15137C20.6857 6.87216 18.6886 6.65907 16.6137 7.16607C14.7606 7.6187 13.3469 8.31528 12.3153 9.06623C12.2638 9.10444 12.2007 9.03684 12.2433 8.98687ZM18.1919 22.36C18.1919 22.3614 18.1934 22.3614 18.1934 22.3629C18.1919 22.3614 18.1919 22.3614 18.1919 22.36ZM23.1178 22.9419C23.1531 22.9272 23.1781 22.8861 23.1736 22.8464C23.1692 22.7964 23.1251 22.7612 23.0752 22.7656C23.0752 22.7656 20.5255 23.1433 18.1185 22.2615C18.38 21.4092 19.0781 21.7163 20.1317 21.8015C22.0318 21.9147 23.735 21.6369 24.9929 21.2754C26.0833 20.9624 27.5161 20.3452 28.6285 19.4679C29.0033 20.2923 29.137 21.199 29.137 21.199C29.137 21.199 29.428 21.1476 29.6704 21.296C29.8997 21.4371 30.0687 21.731 29.9526 22.4893C29.7189 23.9074 29.1164 25.0566 28.1039 26.1147C27.4882 26.7775 26.7387 27.3551 25.8835 27.7739C25.4178 28.018 24.9327 28.223 24.433 28.3867C20.6152 29.6329 16.7092 28.2632 15.4498 25.3197C15.3499 25.0978 15.2646 24.8671 15.197 24.6246C14.6606 22.6848 15.1162 20.3584 16.5402 18.8933V18.8918C16.6284 18.7992 16.718 18.689 16.718 18.5508C16.718 18.4347 16.6445 18.3128 16.5813 18.2261C16.0832 17.503 14.3565 16.2715 14.7033 13.8879C14.9516 12.1758 16.4491 10.9693 17.8451 11.0413C17.9627 11.0472 18.0817 11.0546 18.1993 11.0619C18.8047 11.0972 19.3323 11.1751 19.8305 11.1956C20.6637 11.2324 21.4131 11.1104 22.3022 10.3712C22.602 10.1214 22.8415 9.90535 23.2486 9.83628C23.2912 9.82893 23.397 9.79073 23.6101 9.80101C23.8261 9.81277 24.0333 9.87155 24.2185 9.995C24.9297 10.4682 25.0311 11.6159 25.0679 12.4551C25.0884 12.9341 25.1472 14.0936 25.1663 14.4258C25.2119 15.187 25.4117 15.2943 25.8159 15.4265C26.0436 15.5015 26.2552 15.5573 26.5653 15.644C27.5073 15.9086 28.0657 16.1775 28.4184 16.5214C28.6285 16.7374 28.7255 16.9652 28.7564 17.1841C28.8681 17.9953 28.1274 18.9961 26.1671 19.9058C24.0245 20.9007 21.4249 21.152 19.6291 20.9521C19.491 20.9374 19.0016 20.8816 19.0002 20.8816C17.563 20.6876 16.7444 22.5451 17.6071 23.8163C18.1625 24.6363 19.6762 25.1698 21.1898 25.1698C24.6623 25.1698 27.3295 23.687 28.3229 22.407C28.3523 22.3688 28.3552 22.3644 28.4022 22.2938C28.4507 22.2204 28.411 22.1792 28.3493 22.2218C27.5381 22.7773 23.9363 24.9802 20.0832 24.3174C20.0832 24.3174 19.6144 24.241 19.1883 24.075C18.8488 23.9427 18.1376 23.6165 18.0509 22.8861C21.1589 23.8516 23.1178 22.9419 23.1178 22.9419ZM6.03744 15.5514C4.95587 15.7616 4.00214 16.3744 3.42021 17.2209C3.07193 16.9299 2.4224 16.3685 2.30777 16.1481C1.37756 14.3817 3.32322 10.9458 4.68253 9.00597C8.04335 4.21223 13.3057 0.583857 15.7408 1.24222C16.1375 1.35391 17.4483 2.87492 17.4483 2.87492C17.4483 2.87492 15.0133 4.22546 12.7561 6.10945C9.71274 8.45195 7.41439 11.8569 6.03744 15.5514ZM7.85525 23.6605C7.69213 23.6885 7.52461 23.7002 7.35561 23.6958C5.72884 23.6517 3.97128 22.1866 3.79641 20.4495C3.6039 18.5288 4.58408 17.0519 6.32106 16.7007C6.52826 16.6595 6.77955 16.6345 7.04995 16.6492C8.02278 16.7021 9.45704 17.4501 9.78475 19.5707C10.0772 21.4474 9.61575 23.3593 7.85525 23.6605ZM29.8967 20.26C29.8835 20.21 29.7924 19.8793 29.6675 19.4781C29.5426 19.0784 29.4133 18.7963 29.4133 18.7963C29.9144 18.0468 29.9232 17.3767 29.8556 16.9975C29.7851 16.5272 29.5881 16.1261 29.1943 15.7116C28.799 15.2972 27.9922 14.8725 26.8578 14.5536C26.7284 14.5169 26.3008 14.3993 26.2626 14.389C26.2597 14.364 26.2317 12.9856 26.2053 12.3933C26.1862 11.9657 26.1494 11.297 25.9422 10.6387C25.6954 9.74811 25.2648 8.96924 24.7284 8.46958C26.2112 6.93241 27.137 5.23946 27.134 3.78752C27.1296 0.993867 23.6997 0.148863 19.4734 1.89912C19.469 1.90059 18.5843 2.2768 18.5784 2.27974C18.574 2.27533 16.959 0.691135 16.9355 0.670561C12.1154 -3.53095 -2.95315 13.2178 1.86397 17.2855L2.91616 18.1776C2.64283 18.8844 2.53555 19.6956 2.62372 20.5671C2.73688 21.6869 3.3144 22.7597 4.24902 23.5885C5.13809 24.3762 6.30637 24.8744 7.43937 24.8729C9.3145 29.1935 13.5982 31.8431 18.6196 31.993C24.0069 32.1532 28.5286 29.6255 30.4243 25.0846C30.5477 24.7657 31.0738 23.3299 31.0738 22.0617C31.0768 20.7875 30.3552 20.26 29.8967 20.26Z"
                    fill="#231F20"
                  />
                </svg>
              </span>
              <span v-else class="mr-3" style="padding-top: 1px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1953 3.5286C10.4556 3.26825 10.8777 3.26825 11.1381 3.5286L15.1381 7.5286C15.3984 7.78895 15.3984 8.21106 15.1381 8.47141L11.1381 12.4714C10.8777 12.7318 10.4556 12.7318 10.1953 12.4714C9.93493 12.2111 9.93493 11.7889 10.1953 11.5286L13.7239 8L10.1953 4.47141C9.93493 4.21106 9.93493 3.78895 10.1953 3.5286Z"
                    fill="#8F92A3"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.80476 3.5286C6.06511 3.78895 6.06511 4.21106 5.80476 4.47141L2.27616 8L5.80476 11.5286C6.06511 11.7889 6.06511 12.2111 5.80476 12.4714C5.54441 12.7318 5.1223 12.7318 4.86195 12.4714L0.861949 8.47141C0.6016 8.21106 0.6016 7.78895 0.861949 7.5286L4.86195 3.5286C5.1223 3.26825 5.54441 3.26825 5.80476 3.5286Z"
                    fill="#8F92A3"
                  />
                </svg>
              </span>
              <span class="body-regular-small textType3--text">
                {{ getIntegrationName(integration.service) }}
              </span>
            </v-col>
            <v-col cols="7" class="d-flex justify-end align-center">
              <v-progress-circular
                v-if="
                  loadings.removeIntegration &&
                  beingRemovedIntegration === integration.service
                "
                width="2"
                size="16"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <template v-else>
                <v-btn icon @click="handleEditIntegration(integration)">
                  <v-icon size="16px">panda-edit</v-icon>
                </v-btn>
                <v-menu bottom left offset-y min-width="150px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon size="16px">panda-menu-action</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="pa-0 py-2">
                    <v-list-item
                      class="pb-2"
                      @click="handleEditIntegration(integration)"
                    >
                      <v-list-item-icon
                        ><v-icon size="16px"
                          >panda-edit</v-icon
                        ></v-list-item-icon
                      >
                      <v-list-item-title>
                        {{ $t('message.edit') }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider />
                    <v-list-item
                      class="pt-2"
                      @click="handleDeleteIntegration(integration)"
                    >
                      <v-list-item-icon
                        ><v-icon color="feedback-danger" size="16px"
                          >panda-remove</v-icon
                        ></v-list-item-icon
                      >
                      <v-list-item-title class="error--text">
                        {{ $t('message.pages.integrations.remove') }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" class="pa-0 mb-2">
          <base-btn
            type="secondary"
            @click="handleConfigCRM"
            :disabled="!canAddIntegration"
          >
            <span>{{ $t('message.pages.integrations.addIntegration') }}</span>
          </base-btn>
        </v-col>
      </v-card>

      <!-- Divisor -->
      <v-row class="mx-n3 my-0">
        <v-divider class="mt-3"></v-divider>
      </v-row>

      <!-- Seção de Customização -->
      <v-col cols="12" class="px-4 pt-5">
        <v-row justify="center" align="center">
          <span class="body-regular-smaller textType6--text pt-4">{{
            $t('message.pages.integrations.general')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenus.general = !showingMenus.general"
          >
            <v-icon v-if="showingMenus.general">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenus.general">
          <v-row align="center">
            <v-col cols="9" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.pauseInStart')
              }}</span
              ><br />
            </v-col>
            <v-col cols="3" class="pa-0 d-flex justify-end">
              <v-switch
                v-model="generalData.pauseVideo"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="9" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.pauseInEnd')
              }}</span
              ><br />
            </v-col>
            <v-col cols="3" class="pa-0 d-flex justify-end">
              <v-switch
                v-model="generalData.pauseVideoEnd"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="9" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.selectName')
              }}</span
              ><br />
            </v-col>
            <v-col cols="3" class="pa-0 d-flex justify-end">
              <v-switch
                v-model="generalData.general.showNameField"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="9" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.selectLastName')
              }}</span
              ><br />
            </v-col>
            <v-col cols="3" class="pa-0 d-flex justify-end">
              <v-switch
                v-model="generalData.general.showLastNameField"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="9" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.allowSkipForm')
              }}</span
              ><br />
            </v-col>
            <v-col cols="3" class="pa-0 d-flex justify-end">
              <v-switch
                v-model="generalData.general.allowSkip"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </template>
        <v-row class="mx-n7 my-0">
          <v-divider class="mt-8"></v-divider>
        </v-row>
        <v-row justify="center" align="center">
          <span class="body-regular-smaller textType6--text pt-3">{{
            $t('message.pages.integrations.headline')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenus.headline = !showingMenus.headline"
          >
            <v-icon v-if="showingMenus.headline">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenus.headline">
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.text')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 pt-2">
              <v-textarea
                style="font-size: 13px"
                v-model="generalData.headline.text"
                :counter="160"
                auto-grow
                rows="1"
                :rules="[rules.required, rules.maxLength160]"
                :placeholder="$t('message.pages.integrations.headlineText')"
                @focus="isHeadlineFocused = true"
                @blur="isHeadlineFocused = false"
                :hide-details="!isHeadlineFocused"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.size')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-slider
                v-model="generalData.headline.fontSize"
                class="mt-6"
                thumb-label
                :max="48"
                :min="16"
                hide-details
              >
                <template v-slot:append>
                  <v-input
                    style="font-size: 13px; width: 62px"
                    v-model="headlineFontSizeValue"
                    class="mt-n2"
                    hide-details
                    type="number"
                    suffix="px"
                    @keypress="preventInvalidInput($event, 'headlineFontSize')"
                    @paste="handlePaste($event, 'headlineFontSize')"
                    :max="48"
                    :min="16"
                  ></v-input>
                </template>
              </v-slider>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.drm.drmApparence.colorText')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 d-flex justify-end">
              <v-row align="center" class="d-flex justify-end pt-5 mr-1">
                <v-menu
                  v-model="showingMenus.headlineFontColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.headline.color"
                      :style="
                        setColor(
                          showingMenus.headlineFontColorMenuOpen,
                          generalData.headline.color
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.headline.color
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.headline.color"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <v-row class="mx-n7 my-0">
          <v-divider class="mt-8"></v-divider>
        </v-row>
        <v-row justify="center" align="center">
          <span class="body-regular-smaller textType6--text pt-3">{{
            $t('message.pages.integrations.subHeadline')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenus.subHeadline = !showingMenus.subHeadline"
          >
            <v-icon v-if="showingMenus.subHeadline">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenus.subHeadline">
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.text')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 pt-2">
              <v-textarea
                style="font-size: 13px"
                v-model="generalData.subHeadline.text"
                :counter="160"
                auto-grow
                rows="1"
                :rules="[rules.maxLength160]"
                :placeholder="$t('message.pages.integrations.subHeadlineText')"
                @focus="isSubHeadlineFocused = true"
                @blur="isSubHeadlineFocused = false"
                :hide-details="!isSubHeadlineFocused"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.size')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-slider
                v-model="generalData.subHeadline.fontSize"
                class="mt-6"
                thumb-label
                :max="48"
                :min="16"
                hide-details
              >
                <template v-slot:append>
                  <v-input
                    style="font-size: 13px; width: 62px"
                    v-model="subHeadlineFontSizeValue"
                    dense
                    class="mt-n2"
                    outlined
                    hide-details
                    type="number"
                    suffix="px"
                    @keypress="
                      preventInvalidInput($event, 'subHeadlineFontSize')
                    "
                    @paste="handlePaste($event, 'subHeadlineFontSize')"
                    :max="48"
                    :min="16"
                  ></v-input>
                </template>
              </v-slider>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.drm.drmApparence.colorText')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-row align="center" class="d-flex justify-end pt-5 mr-1">
                <v-menu
                  v-model="showingMenus.subHeadlineFontColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.subHeadline.color"
                      :style="
                        setColor(
                          showingMenus.subHeadlineFontColorMenuOpen,
                          generalData.subHeadline.color
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.subHeadline.color
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.subHeadline.color"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <v-row class="mx-n7 my-0">
          <v-divider class="mt-8"></v-divider>
        </v-row>
        <v-row justify="center" align="center">
          <span class="body-regular-smaller textType6--text pt-3">{{
            $t('message.pages.integrations.sendButton')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenus.sendButton = !showingMenus.sendButton"
          >
            <v-icon v-if="showingMenus.sendButton">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenus.sendButton">
          <v-row align="center" class="pt-3">
            <v-col cols="5" class="pa-0 ma-0">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.textButton')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 pt-2">
              <v-input
                style="font-size: 13px"
                :rules="[rules.required]"
                v-model="generalData.sendButton.text"
                :placeholder="$t('message.pages.integrations.textButtonText')"
              ></v-input>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.drm.drmApparence.colorText')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-row align="center" class="d-flex justify-end pt-5 mr-1">
                <v-menu
                  v-model="showingMenus.sendButtonTextFontColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.sendButton.color"
                      :style="
                        setColor(
                          showingMenus.sendButtonTextFontColorMenuOpen,
                          generalData.sendButton.color
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.sendButton.color
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.sendButton.color"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text">
                {{ $t('message.pages.drm.drmApparence.colorText') }}
                (hover)</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-row align="center" class="d-flex justify-end pt-5 mr-1">
                <v-menu
                  v-model="showingMenus.sendButtonTextHoverFontColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.sendButton.colorHover"
                      :style="
                        setColor(
                          showingMenus.sendButtonTextHoverFontColorMenuOpen,
                          generalData.sendButton.colorHover
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.sendButton.colorHover
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.sendButton.colorHover"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.drm.settingsForm.backgroundColor')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-row align="center" class="d-flex justify-end pt-5 mr-1">
                <v-menu
                  v-model="showingMenus.sendButtonBackgroundColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.sendButton.backgroundColor"
                      :style="
                        setColor(
                          showingMenus.sendButtonBackgroundColorMenuOpen,
                          generalData.sendButton.backgroundColor
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.sendButton.backgroundColor
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.sendButton.backgroundColor"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text"
                >{{
                  $t('message.pages.drm.settingsForm.backgroundColor')
                }}
                (hover)</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-row align="center" class="d-flex justify-end pt-5 mr-1">
                <v-menu
                  v-model="showingMenus.sendButtonBackgroundHoverColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.sendButton.backgroundColorHover"
                      :style="
                        setColor(
                          showingMenus.sendButtonBackgroundHoverColorMenuOpen,
                          generalData.sendButton.backgroundColorHover
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.sendButton.backgroundColorHover
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.sendButton.backgroundColorHover"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <v-row class="mx-n7 my-0">
          <v-divider class="mt-8"></v-divider>
        </v-row>
        <v-row justify="center" align="center" class="pt-3">
          <span class="body-regular-smaller textType6--text">{{
            $t('message.pages.integrations.BACKGROUND')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenus.background = !showingMenus.background"
          >
            <v-icon v-if="showingMenus.background">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenus.background">
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-5">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.color')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-row align="center" class="d-flex justify-end mr-1">
                <v-menu
                  v-model="showingMenus.backgroundColorMenuOpen"
                  offset-x
                  top
                  nudge-bottom="105"
                  nudge-left="16"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="generalData.background.color"
                      :style="
                        setColor(
                          showingMenus.backgroundColorMenuOpen,
                          generalData.background.color
                        )
                      "
                      v-on="on"
                      icon
                      class="rounded-pill border-slate"
                    >
                      <span class="describeHexa">{{
                        generalData.background.color
                      }}</span></v-btn
                    >
                  </template>
                  <v-color-picker
                    elevation="3"
                    v-model="generalData.background.color"
                    flat
                    mode="hexa"
                    hide-mode-switch
                    :maxlength="7"
                  ></v-color-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5" class="pa-0 ma-0 pt-3">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.opacity')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7" class="pa-0 ma-0">
              <v-slider
                v-model="generalData.background.opacity"
                class="mt-6"
                thumb-label
                :max="100"
                :min="0"
                hide-details
              >
                <template v-slot:append>
                  <v-input
                    style="font-size: 13px; width: 62px"
                    v-model="backgroundOpacityValue"
                    dense
                    class="mt-n2"
                    outlined
                    hide-details
                    type="number"
                    suffix="%"
                    @keypress="preventInvalidInput($event, 'backgroundOpacity')"
                    @paste="handlePaste($event, 'backgroundOpacity')"
                    :max="100"
                    :min="0"
                  ></v-input>
                </template>
              </v-slider>
            </v-col>
          </v-row>
        </template>
        <v-row class="mx-n7 my-0">
          <v-divider class="mt-8"></v-divider>
        </v-row>
        <v-row justify="center" align="center" class="pt-3">
          <span class="body-regular-smaller textType6--text">{{
            $t('message.pages.integrations.fieldText')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenus.textFields = !showingMenus.textFields"
          >
            <v-icon v-if="showingMenus.textFields">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenus.textFields">
          <v-row
            v-if="generalData.general.showNameField"
            class="pt-4 d-flex align-center"
          >
            <v-col cols="5" class="pa-0 ma-0 d-flex align-center">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.fieldName')
              }}</span>
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 d-flex align-center">
              <v-input
                style="font-size: 13px"
                v-model="generalData.textFields.name"
                hide-details
                :rules="[rules.required]"
                :placeholder="$t('message.pages.integrations.nameText')"
              ></v-input>
            </v-col>
          </v-row>
          <v-row
            v-if="generalData.general.showLastNameField"
            class="pt-4 d-flex align-center"
          >
            <v-col cols="5" class="pa-0 ma-0 d-flex align-center">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.fieldLastName')
              }}</span>
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 d-flex align-center">
              <v-input
                style="font-size: 13px"
                v-model="generalData.textFields.lastName"
                hide-details
                :rules="[rules.required]"
                :placeholder="$t('message.pages.integrations.lastNameText')"
              ></v-input>
            </v-col>
          </v-row>
          <v-row align="center" class="pt-4 d-flex align-center">
            <v-col cols="5" class="pa-0 ma-0 d-flex align-center">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.fieldEmail')
              }}</span>
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 d-flex align-center">
              <v-input
                style="font-size: 13px"
                v-model="generalData.textFields.email"
                hide-details
                :rules="[rules.required]"
                :placeholder="$t('message.pages.integrations.emailText')"
              ></v-input>
            </v-col>
          </v-row>
          <v-row align="center" class="pt-4 d-flex align-center">
            <v-col cols="5" class="pa-0 ma-0 d-flex align-center">
              <span class="body-regular-small textType3--text">{{
                $t('message.pages.integrations.fieldInvalidEmail')
              }}</span>
            </v-col>
            <v-col cols="7" class="pa-0 ma-0 d-flex align-center">
              <v-input
                style="font-size: 13px"
                v-model="generalData.textFields.invalidEmailText"
                hide-details
                :rules="[rules.required]"
                :placeholder="$t('message.pages.integrations.invalidEmailText')"
              ></v-input>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </div>

    <!-- Portal para ações de salvamento -->
    <portal to="actions-footer">
      <div class="d-flex flex-row actions-row">
        <v-spacer></v-spacer>
        <v-tooltip max-width="184px" top :disabled="withoutChanges">
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                type="tertiary"
                class="mr-2 px-4"
                text
                :disabled="withoutChanges"
                @click="handleUndoChanges"
              >
                {{ $t('message.actions.cancel') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
        <div class="pl-2">
          <base-btn
            type="primary"
            :loading="loadings.fetching"
            :disabled="withoutChanges || !isValidForSave"
            width="150"
            @click="handleSave"
            :tooltip="
              !isValidForSave
                ? getValidationMessage
                : withoutChanges
                ? $t('message.noChanges')
                : ''
            "
          >
            <span class="px-5">{{ $t('message.actions.publish') }}</span>
          </base-btn>
        </div>
      </div>
    </portal>

    <video-player-form-modal />
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import playerApi from '@/services/playerApi'
import VideoPlayerFormModal from './VideoPlayerFormModal.vue'
import integrationsApi from '@/services/integrationsApi'
import { isEmpty } from '@aws-amplify/core'
import _ from 'lodash'
import ctaRedirectMixin from '@/mixins/ctaRedirectMixin'

export default {
  name: 'VideoPlayerForm',
  components: { VideoPlayerFormModal },
  mixins: [ctaRedirectMixin],
  data() {
    return {
      isSubHeadlineFocused: false,
      isHeadlineFocused: false,
      isTimelineDragging: false,
      isExistentCta: false,
      rules: {
        required: (v) => (v && !!v) || this.$t('message.requiredFill'),
        maxLength160: (v) =>
          !v || v.length <= 160 || this.$t('message.maximumLength160'),
      },
      initialGeneralData: {},
      isInitializing: false,
      generalDataDefault: {
        textFields: {
          name: this.$i18next.t('message.name'),
          lastName: this.$i18next.t('message.pages.login.insertLastName'),
          email: this.$i18next.t('message.pages.login.email'),
          invalidEmailText: this.$i18next.t('message.invalidEmail'),
        },
        background: {
          color: '#000000',
          opacity: 65,
        },
        sendButton: {
          text: this.$i18next.t('message.send'),
          color: '#FFFFFF',
          colorHover: '#FFFFFF',
          backgroundColor: '#3F55EE',
          backgroundColorHover: '#000000',
        },
        headline: {
          text: this.$i18next.t('message.pages.videoPlayerForm.emailDetails'),
          fontSize: 16,
          color: '#FFFFFF',
        },
        subHeadline: {
          text: this.$i18next.t(
            'message.pages.videoPlayerForm.receiveMaterial'
          ),
          fontSize: 16,
          color: '#FFFFFF',
        },
        integrations: [],
        startTime: 0,
        duration: 0,
        id: null,
        pauseVideo: false,
        pauseVideoEnd: false,
        general: {
          showNameField: true,
          showLastNameField: true,
          allowSkip: true,
        },
      },
      generalData: {},
      showingMenus: {
        general: true,
        headline: true,
        subHeadline: true,
        sendButton: true,
        background: true,
        integrations: true,
        textFields: true,
        headlineFontColorMenuOpen: false,
        subHeadlineFontColorMenuOpen: false,
        sendButtonTextFontColorMenuOpen: false,
        sendButtonBackgroundColorMenuOpen: false,
        sendButtonBackgroundHoverColorMenuOpen: false,
        sendButtonTextHoverFontColorMenuOpen: false,
        backgroundColorMenuOpen: false,
      },
      integrations: [],
      loadings: {
        getIntegrations: false,
        removeIntegration: false,
        fetching: false,
      },
      beingRemovedIntegration: '',
    }
  },
  methods: {
    setColor(menuOpen, color) {
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menuOpen ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    ...mapMutations('dashboard', ['UPDATE_VIDEO_TIMELINE_ITEMS']),
    ...mapMutations('video', [
      'UPDATE_LOADING_SAVE',
      'UPDATE_VIDEO_CONFIG_CTAS',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    getIntegrationName(serviceName) {
      if (serviceName === 'mailchimp') {
        return 'Mailchimp'
      } else if (serviceName === 'active_campaign') {
        return 'Active Campaign'
      } else if (serviceName === 'webhook') {
        return 'Webhook'
      } else if (serviceName === 'clickmax') {
        return 'ClickMax'
      } else {
        return '-'
      }
    },
    loadInitialData() {
      this.isInitializing = true
      this.generalData = _.cloneDeep(this.generalDataDefault)

      const videoConfigFormItem = this.video?.config?.ctas
        ? this.video.config.ctas.find(
            (cta) => cta.id === this.$route.params.formId
          )
        : null
      this.isExistentCta = !!videoConfigFormItem

      const timelineFormItem = this.timelineItems.find(
        (item) => item?.data?.id === this.$route.params.formId
      )

      this.generalData.id =
        timelineFormItem?.data?.id || this.$route.params.formId

      if (!_.isEmpty(timelineFormItem)) {
        this.generalData = {
          ...this.generalData,
          ..._.cloneDeep(timelineFormItem.data.metadata?.generalData || {}),
        }

        this.generalData.startTime = timelineFormItem.data.metadata?.startTime
        this.generalData.endTime = timelineFormItem.data.metadata?.endTime
        this.generalData.duration = timelineFormItem.data.duration
      }

      if (videoConfigFormItem && videoConfigFormItem.metadata?.generalData) {
        this.initialGeneralData = _.cloneDeep(
          videoConfigFormItem.metadata.generalData
        )
        // Carregar integrações se existirem no vídeo config
        if (videoConfigFormItem.metadata.generalData.integrations) {
          this.generalData.integrations = _.cloneDeep(
            videoConfigFormItem.metadata.generalData.integrations
          )
        }
      } else {
        this.initialGeneralData = _.cloneDeep(this.generalData)
      }

      // Carregar integrações se existirem no timeline item
      if (
        timelineFormItem &&
        timelineFormItem.data.metadata?.generalData?.integrations
      ) {
        this.generalData.integrations = _.cloneDeep(
          timelineFormItem.data.metadata.generalData.integrations
        )
      }

      this.updateHasNoChangesState(this.withoutChanges)

      this.loadCtaData()
      this.updatePlayerCtas()

      this.$nextTick(() => {
        this.isInitializing = false
        this.updatePlayerCtas()
      })
    },
    handleUpdateCurrentTime() {
      this.generalData.startTime = this.timelineItem.data.metadata.startTime
      this.generalData.endTime = this.timelineItem.data.metadata.endTime
      this.generalData.duration = this.timelineItem.data.duration
    },
    handleConfigCRM() {
      this.$root.$emit('openVideoPlayerFormModal', null, this.integrations)
    },
    updateSaveArray() {
      const ctaData = this.generateEditingCta()
      console.log('ctaData', ctaData)
      // const index = this.$globalSettings.saveArray.findIndex(
      //   (el) => el.ctaId === ctaData.id
      // )
      // if (index !== -1) {
      //   this.$globalSettings.saveArray[index].ctaData = ctaData
      // } else {
      //   this.$globalSettings.saveArray.push({
      //     ctaData: ctaData,
      //     ctaId: ctaData.id,
      //   })
      // }
    },
    async handleIntegrations() {
      this.loadings.getIntegrations = true
      await this.getIntegrations()
      this.loadings.getIntegrations = false
    },
    async getIntegrations() {
      this.loadings.getIntegrations = true
      try {
        let ret = await integrationsApi.getIntegrations()
        this.integrations = ret.data
      } catch (e) {
        console.error('Error fetching integrations:', e)
        this.handleErrorSnackbar(
          e?.response?.data?.errMsg ||
            e?.response?.data?.message ||
            this.$t('message.errors.networkError')
        )
      }
    },
    handleEditIntegration(integration) {
      this.$root.$emit(
        'openVideoPlayerFormModal',
        integration,
        this.integrations
      )
    },
    async handleDeleteIntegration(integration) {
      this.loadings.removeIntegration = true
      this.beingRemovedIntegration = integration.service
      try {
        await integrationsApi.deleteIntegration(integration.id)
        this.integrations = [...this.integrations].filter(function (item) {
          return item.service !== integration.service
        })
        this.handleSnackbar(this.$t('message.pages.integrations.removeSuccess'))
        this.loadings.removeIntegration = false
      } catch (e) {
        console.error('Error deleting integration:', e)
        this.handleErrorSnackbar(
          e?.response?.data?.errMsg ||
            e?.response?.data?.message ||
            this.$t('message.errors.unexpectedError')
        )
        this.loadings.removeIntegration = false
      }
    },
    hexToRgba(hex, opacity) {
      const hexColor = hex.replace('#', '')
      const r = parseInt(hexColor.substring(0, 2), 16)
      const g = parseInt(hexColor.substring(2, 4), 16)
      const b = parseInt(hexColor.substring(4, 6), 16)
      return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`
    },
    updatePlayerCtas() {
      if (
        this.isInitializing ||
        !this.generalData?.id ||
        this.isTimelineDragging ||
        !this.timelineItems
      ) {
        return
      }

      const newTimelineItems = this.timelineItems.map((item) => {
        if (isEmpty(item)) return item
        if (item.data?.id === this.generalData.id) {
          item.data = {
            script: this.generatedScript,
            type: 'video',
            time: this.elementTimes?.startTime || 0,
            duration: this.elementTimes?.duration || 10,
            metadata: {
              generalData: this.generalData,
              ctaType: 'form',
              startTime: this.elementTimes?.startTimeStr || '00:00',
              endTime: this.elementTimes?.endTimeStr || '00:10',
            },
            pauseVideo: this.generalData.pauseVideo,
            pauseVideoEnd: this.generalData.pauseVideoEnd,
            maxZIndex: true,
            id: this.generalData.id,
          }
        }
        return item
      })
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...newTimelineItems])
      this.$root.$emit('reloadPlayerCtas')
    },

    loadCtaData() {
      const ctaData = {
        script: this.generatedScript,
        type: 'video',
        time: this.elementTimes.startTime,
        duration: this.elementTimes.duration,
        metadata: {
          generalData: this.generalData,
          ctaType: 'form',
          startTime: this.elementTimes.startTimeStr,
          endTime: this.elementTimes.endTimeStr,
        },
        pauseVideo: this.generalData.pauseVideo,
        pauseVideoEnd: this.generalData.pauseVideoEnd,
        maxZIndex: true,
        id: this.generalData.id,
      }
      console.log('ctaData', ctaData)
    },
    generateEditingCta() {
      return {
        script: this.generatedScript,
        type: 'video',
        time: this.elementTimes.startTime,
        duration: this.elementTimes.duration,
        metadata: {
          generalData: this.generalData,
          ctaType: 'form',
          startTime: this.elementTimes.startTimeStr,
          endTime: this.elementTimes.endTimeStr,
        },
        pauseVideo: this.generalData.pauseVideo,
        pauseVideoEnd: this.generalData.pauseVideoEnd,
        maxZIndex: true,
        id: this.generalData.id,
      }
    },
    async handleSave() {
      this.loadings.fetching = true
      try {
        const ctaData = this.generateEditingCta()
        const { data } = await playerApi.addCta(this.video.id, ctaData)
        this.UPDATE_VIDEO_CONFIG_CTAS(data.ctas)
        this.isExistentCta = true
        this.initialGeneralData = _.cloneDeep(this.generalData)
        const timelineItem = this.timelineItems.find(
          (item) => item.data.id === this.$route.params.formId
        )
        timelineItem.isDraft = false
        this.handleSnackbar(this.$t('message.changesSaved'))
        this.$emit('showFooter', true)
        this.loadings.fetching = false
      } catch (error) {
        console.error('Error saving form:', error)
        this.handleErrorSnackbar(
          error?.response?.data?.errMsg ||
            error?.response?.data?.message ||
            this.$t('message.errors.unexpectedError')
        )
        this.loadings.fetching = false
      }
    },

    async handleDelete() {
      this.$root.$emit('updateTimelineLoading', true)
      try {
        const { data } = await playerApi.deleteCta(
          this.video.id,
          this.generalData.id
        )
        this.UPDATE_VIDEO_CONFIG_CTAS(data.ctas)
        this.$root.$emit('updateTimelineLoading', false)
      } catch (error) {
        console.error('Error deleting form:', error)
        this.$root.$emit('updateTimelineLoading', false)
        this.handleErrorSnackbar(
          error?.response?.data?.errMsg ||
            error?.response?.data?.message ||
            this.$t('message.errors.unexpectedError')
        )
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    handleErrorSnackbar(errorMsg) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: errorMsg || this.$t('message.errors.unexpectedError'),
        type: 'error',
      })
    },
    updateHasNoChangesState(val) {
      // Evitar executar durante inicialização
      if (this.isInitializing || !this.generalData.id) {
        return
      }

      const timelineInfoItem = this.timelineItems.find(
        (item) => item.data.id === this.generalData.id
      )
      if (timelineInfoItem) {
        timelineInfoItem.hasChanges = !val
        this.$root.$emit('reRenderTimelineItems')
      }
    },
    handleUndoChanges() {
      this.generalData = _.cloneDeep(this.initialGeneralData)
      this.handleSnackbar(this.$t('message.actions.discardChanges'))
    },
    preventInvalidInput(event, field) {
      const currentValue = this.getCurrentValueForField(field)
      const key = event.key
      const currentValueStr = currentValue.toString()
      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          'Backspace',
          'Delete',
          'Tab',
          'Enter',
          'ArrowLeft',
          'ArrowRight',
          'ArrowUp',
          'ArrowDown',
        ].includes(key)
      ) {
        return
      }
      if (!/[0-9]/.test(key)) {
        event.preventDefault()
        return
      }
      const input = event.target
      const selectionStart = input.selectionStart || 0
      const selectionEnd = input.selectionEnd || 0

      const newValue =
        currentValueStr.substring(0, selectionStart) +
        key +
        currentValueStr.substring(selectionEnd)

      if (newValue.length > 3) {
        event.preventDefault()
        return
      }

      const numericValue = parseInt(newValue) || 0
      if (field === 'backgroundOpacity') {
        if (numericValue > 100) {
          event.preventDefault()
        }
      } else {
        if (numericValue > 48 || numericValue < 16) {
          event.preventDefault()
        }
      }
    },

    handlePaste(event, field) {
      event.preventDefault()
      const paste = (event.clipboardData || window.clipboardData).getData(
        'text'
      )

      const cleanPaste = paste.replace(/[^0-9]/g, '').substring(0, 3)
      const numericValue = parseInt(cleanPaste) || 0
      const clampedValue = Math.max(0, Math.min(100, numericValue))

      this.setValueForField(field, clampedValue)
    },

    getCurrentValueForField(field) {
      switch (field) {
        case 'headlineFontSize':
          return this.generalData.headline.fontSize
        case 'subHeadlineFontSize':
          return this.generalData.subHeadline.fontSize
        case 'backgroundOpacity':
          return this.generalData.background.opacity
        default:
          return 0
      }
    },

    setValueForField(field, value) {
      switch (field) {
        case 'headlineFontSize':
          this.generalData.headline.fontSize = value
          break
        case 'subHeadlineFontSize':
          this.generalData.subHeadline.fontSize = value
          break
        case 'backgroundOpacity':
          this.generalData.background.opacity = value
          break
      }
    },

    beforeLeave() {
      this.$router.push({
        name: 'VideoPage',
        params: { id: this.$route.params.id },
      })
    },
  },
  mounted() {
    this.handleIntegrations()
    this.$root.$on('handleDeleteForm', async () => {
      await this.handleDelete()
    })
    this.$root.$on('updatePlayerForm', async (action) => {
      this.UPDATE_LOADING_SAVE(true)
      await this.handleSave()
      this.UPDATE_LOADING_SAVE(false)
      this.$root.$emit(action, true)
    })
    this.$root.$on('reloadIntegrations', async () => {
      this.handleIntegrations()
    })
    this.$root.$on('timelineDrag', (isDragging) => {
      this.isTimelineDragging = isDragging
    })

    this.loadInitialData()
    this.$emit('showFooter', true)
  },
  beforeDestroy() {
    this.$root.$off('updatePlayerForm')
    this.$root.$off('handleDeleteForm')
    this.$root.$off('timelineDrag')
  },
  computed: {
    canAddIntegration() {
      return this.integrations.length < 3
    },
    isValidForSave() {
      const hasTitleValid =
        this.generalData.headline.text &&
        this.generalData.headline.text.trim() !== ''
      const hasButtonTextValid =
        this.generalData.sendButton.text &&
        this.generalData.sendButton.text.trim() !== ''
      const hasNameFieldValid =
        !this.generalData.general.showNameField ||
        (this.generalData.textFields.name &&
          this.generalData.textFields.name.trim() !== '')
      const hasLastNameFieldValid =
        !this.generalData.general.showLastNameField ||
        (this.generalData.textFields.lastName &&
          this.generalData.textFields.lastName.trim() !== '')
      const hasEmailFieldValid =
        this.generalData.textFields.email &&
        this.generalData.textFields.email.trim() !== ''
      const hasInvalidEmailTextValid =
        this.generalData.textFields.invalidEmailText &&
        this.generalData.textFields.invalidEmailText.trim() !== ''

      return (
        hasTitleValid &&
        hasButtonTextValid &&
        hasNameFieldValid &&
        hasLastNameFieldValid &&
        hasEmailFieldValid &&
        hasInvalidEmailTextValid
      )
    },
    getValidationMessage() {
      if (
        !this.generalData.headline.text ||
        this.generalData.headline.text.trim() === ''
      ) {
        return this.$t('message.requiredFill')
      }
      if (
        !this.generalData.sendButton.text ||
        this.generalData.sendButton.text.trim() === ''
      ) {
        return this.$t('message.requiredFill')
      }
      if (
        this.generalData.general.showNameField &&
        (!this.generalData.textFields.name ||
          this.generalData.textFields.name.trim() === '')
      ) {
        return this.$t('message.requiredFill')
      }
      if (
        this.generalData.general.showLastNameField &&
        (!this.generalData.textFields.lastName ||
          this.generalData.textFields.lastName.trim() === '')
      ) {
        return this.$t('message.requiredFill')
      }
      if (
        !this.generalData.textFields.email ||
        this.generalData.textFields.email.trim() === ''
      ) {
        return this.$t('message.requiredFill')
      }
      if (
        !this.generalData.textFields.invalidEmailText ||
        this.generalData.textFields.invalidEmailText.trim() === ''
      ) {
        return this.$t('message.requiredFill')
      }
      return ''
    },
    ...mapState({
      video: (state) => state.video.video,
      timelineItems: (state) => state.dashboard.timelineItems,
    }),
    headlineFontSizeValue: {
      get() {
        return this.generalData.headline.fontSize
      },
      set(value) {
        const stringValue = value
          .toString()
          .replace(/[^0-9]/g, '')
          .substring(0, 2)
        const numValue = parseInt(stringValue) || 16
        const clampedValue = Math.max(16, Math.min(48, numValue))
        this.generalData.headline.fontSize = clampedValue
      },
    },
    subHeadlineFontSizeValue: {
      get() {
        return this.generalData.subHeadline.fontSize
      },
      set(value) {
        const stringValue = value
          .toString()
          .replace(/[^0-9]/g, '')
          .substring(0, 2)
        const numValue = parseInt(stringValue) || 16
        const clampedValue = Math.max(16, Math.min(48, numValue))
        this.generalData.subHeadline.fontSize = clampedValue
      },
    },
    backgroundOpacityValue: {
      get() {
        return this.generalData.background.opacity
      },
      set(value) {
        const stringValue = value
          .toString()
          .replace(/[^0-9]/g, '')
          .substring(0, 3)
        const numValue = parseInt(stringValue) || 0
        const clampedValue = Math.max(0, Math.min(100, numValue))
        this.generalData.background.opacity = clampedValue
      },
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
    leadArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/video-funnel-1k1xo/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/funnel-de-videos-bn0awo/'
      }
      return 'https://help.pandavideo.com/pt-br/article/funil-de-videos-yw6y69/'
    },
    withoutChanges() {
      if (this.isInitializing || !this.generalData.id) {
        return true
      }
      if (!this.isExistentCta) {
        return false
      }

      return _.isEqual(this.generalData, this.initialGeneralData)
    },
    isSomethingLoading() {
      return Object.values(this.loadings).some((loading) => loading === true)
    },
    timelineItem() {
      const foundTimelineItem = this.timelineItems?.find(
        (item) => item?.data?.id === this.$route.params.formId
      )
      return foundTimelineItem || null
    },
    elementTimes() {
      if (
        !this.timelineItem ||
        !this.timelineItem.data ||
        !this.timelineItem.data.metadata
      ) {
        return {
          startTime: 0,
          duration: 10,
          startTimeStr: '00:00',
          endTimeStr: '00:10',
        }
      }

      const startTime = this.timelineItem.data.metadata.startTime
      const startTimeInSeconds =
        parseInt(startTime.split(':')[0]) * 60 +
        parseInt(startTime.split(':')[1])

      const endTime = this.timelineItem.data.metadata.endTime
      const endTimeInSeconds =
        parseInt(endTime.split(':')[0]) * 60 + parseInt(endTime.split(':')[1])

      const duration = endTimeInSeconds - startTimeInSeconds
      return {
        startTime: startTimeInSeconds,
        duration,
        startTimeStr: startTime,
        endTimeStr: endTime,
      }
    },
    generatedScript() {
      const formScript =
        `
                    <style>
                      @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap');
                      
                      #container {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                        width: 100%;
                        background: ${this.hexToRgba(
                          this.generalData.background.color,
                          this.generalData.background.opacity
                        )};
                        font-size: ${this.generalData.headline.fontSize}px;
                        font-family: 'Rubik', sans-serif;
                      }
                      #content {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        width: 100%;
                        padding: 20px;
                        max-width: 400px;
                      }
                      .name-form {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                      }
                      .form-input label {
                        margin-bottom: 3px;
                        font-size: 14px;
                        color: #FFFFFF;
                        font-family: 'Rubik', sans-serif;
                      }
                      .form-input {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                      }
                      h1{
                        font-size: ${this.generalData.headline.fontSize}px;
                        color: ${this.generalData.headline.color};
                        margin: 0;
                        font-family: 'Rubik', sans-serif;
                      }
                      h2{
                        font-size: ${this.generalData.subHeadline.fontSize}px;
                        color: ${this.generalData.subHeadline.color};
                        margin: 15px 0;
                        font-weight: 400;
                        font-family: 'Rubik', sans-serif;
                      }
                      input {
                        padding: 10px;
                        border-radius: 4px;
                        width: 100%;
                        border: 1px solid #EDEEF1;
                        background: #FFFFFF;
                        outline: none;
                        color: #282931;
                        font-family: 'Rubik', sans-serif;
                      }
                      button.send-button {
                        padding: 10px 20px;
                        width: 100%;
                        border-radius: 5px;
                        border: none;
                        background: ${
                          this.generalData.sendButton.backgroundColor
                        };
                        color: ${this.generalData.sendButton.color};
                        cursor: pointer;
                        font-size: 14px;
                        font-family: 'Rubik', sans-serif;
                      }
                      #skip-button{
                        background-color: #EDEEF1;
                        color: #3F404C;
                        padding: 10px 20px;
                        font-size: 14px;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                        outline: none;
                        margin-right: 10px;
                        font-family: 'Rubik', sans-serif;
                      }
                      button.send-button:hover {
                        background: ${
                          this.generalData.sendButton.backgroundColorHover
                        };
                        color: ${this.generalData.sendButton.colorHover};
                      }
                      .send-button-container{
                        display: flex;
                        width: 100%;
                        margin-top: 10px;
                        justify-content: center;
                        align-items: center;
                      }

                    </style>
                    <div id="container">
                      <div id="content">
                        <h1>${this.generalData.headline.text}</h1>
                        <h2>${this.generalData.subHeadline.text}</h2>
                        <div class="name-form" >

                          ${
                            this.generalData.general.showNameField
                              ? `
                            <div class="form-input">
                              <label for="name">${this.generalData.textFields.name}</label>
                              <input type="text" id="name" name="name">
                            </div>
                            `
                              : ''
                          }
                          ${
                            this.generalData.general.showNameField &&
                            this.generalData.general.showLastNameField
                              ? `
                              <div style="width: 30px;">
                              </div>
                            `
                              : ''
                          }
                          ${
                            this.generalData.general.showLastNameField
                              ? `
                            <div class="form-input">
                              <label for="lastName">${this.generalData.textFields.lastName}</label>
                              <input type="text" id="lastName" name="lastName">
                            </div>
                          `
                              : ''
                          }
                        </div>
                        <div class="form-input" style="margin-top: 8px;">
                          <label for="email">${
                            this.generalData.textFields.email
                          }</label>
                          <input type="text" id="email" name="email">
                        </div>
                        <div class="send-button-container">
                          ${
                            this.generalData.general.allowSkip
                              ? `<button id="skip-button">${this.$t(
                                  'message.pages.onboardingModal.skip'
                                )}</button>`
                              : ''
                          }
                          <button class="send-button" id="send-button">${
                            this.generalData.sendButton.text
                          }</button>
                        </div>
                      </div>
                    </div>

                    <script>
                      function handleSendData(){
                        console.log('sending data');
                        const dataToSend = {};
                        if(${this.generalData.general.showNameField}){
                          const nameElement = document.getElementById('name');
                          if(nameElement) {
                            dataToSend.name = nameElement.value;
                          }
                        }
                        if(${this.generalData.general.showLastNameField}){
                          const lastNameElement = document.getElementById('lastName');
                          if(lastNameElement) {
                            if(!dataToSend.name) dataToSend.name='';
                            dataToSend.name += ' '+lastNameElement.value;
                          }
                        }
                        dataToSend.video_name = '${this.video.title}'
                        const emailElement = document.getElementById('email');
                        if(emailElement) {
                          dataToSend.email = emailElement.value;
                        }
                        window.parent.postMessage({
                          type: 'send_form',
                          parameter: dataToSend
                        }, '*');
                        window.parent.postMessage({
                          type: 'remove_cta',
                          parameter: '${this.generalData.id}'
                        }, '*');
                      }
                      let sendButton = document.getElementById('send-button');
                      sendButton.addEventListener('click', handleSendData);
                      document.addEventListener('keydown', function(event) {
                        if (event.key === 'Enter') {
                         handleSendData();
                        }
                      });
                      if(${this.generalData.general.allowSkip}){
                        let skipButton = document.getElementById('skip-button');
                        if(skipButton) {
                          skipButton.addEventListener('click', () => {
                            window.parent.postMessage({
                              type: 'remove_cta',
                              parameter: '${this.generalData.id}'
                            }, '*');
                          });
                        }
                      }

                    </scr` +
        `ipt>
                  `
      return formScript
    },
  },
  watch: {
    '$route.params.formId': {
      handler() {
        if (this.$route.params.formId) {
          this.loadInitialData()
        }
      },
      immediate: true,
    },
    '$route.path': {
      handler() {
        this.loadInitialData()
      },
    },
    'timelineItem.data.duration': {
      handler() {
        this.handleUpdateCurrentTime()
      },
    },
    'timelineItem.data.time': {
      handler() {
        this.handleUpdateCurrentTime()
      },
    },
    generalData: {
      handler() {
        if (this.isInitializing || !this.generalData?.id) {
          return
        }

        this.updatePlayerCtas()
      },
      deep: true,
    },
    withoutChanges: {
      handler(val) {
        if (this.isInitializing || !this.generalData?.id) {
          return
        }

        this.updateHasNoChangesState(val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.border-slate {
  height: 16px !important;
  width: 17px !important;
  border: varFigma(neutral-30-base) 1px solid;
}
.describeHexa {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 10%;
  color: varFigma(neutral-40-light);
  margin-right: 130px;
  width: 100px;
  display: flex;
  justify-content: end;
}
</style>
